import TaxesAndDiscountsEditor from "./TaxesAndDiscountsEditor";

export default TaxesAndDiscountsEditor;
